import React, { useState, useEffect, useRef } from 'react'
import { Box, Heading, Text, Alert, AlertIcon } from '@chakra-ui/react'
import { fetchDetailedBtcSentimentsData } from './utils/cryptoQuantUtils'
import { cryptoQuantStyles } from './styles/cryptoQuantStyles'
import SentimentsTable from './components/SentimentsTable'
import LoadingBubbles from './components/LoadingBubbles'

const CryptoQuantDetailedSentiments: React.FC = () => {
  const [data, setData] = useState<any[][] | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const hasLoadedRef = useRef(false)

  useEffect(() => {
    const loadData = async () => {
      setError(null)
      try {
        const sentimentsData = await fetchDetailedBtcSentimentsData()
        setData(sentimentsData)
      } catch (e) {
        let errorMessage = 'An unknown error occurred'

        if (e instanceof Error) {
          errorMessage = e.message
        } else if (e && typeof e === 'object') {
          try {
            errorMessage = JSON.stringify(e)
          } catch (jsonError) {
            errorMessage = 'Error object could not be stringified'
          }
        }

        setError(errorMessage)
        console.error('Failed to fetch data:', errorMessage)
      } finally {
        setLoading(false)
      }
    }

    if (!hasLoadedRef.current) {
      loadData()
    }
  }, [])

  const renderContent = () => {
    if (error) {
      return (
        <Alert status="error" sx={cryptoQuantStyles.errorAlert}>
          <AlertIcon />
          Error fetching data: {error}
        </Alert>
      )
    }

    if (!data) return <Text>No data available.</Text>

    return <SentimentsTable data={data} />
  }

  return (
    <Box sx={cryptoQuantStyles.container}>
      <Heading sx={cryptoQuantStyles.heading}>CryptoQuant BTC Detailed Sentiments</Heading>
      <Text sx={cryptoQuantStyles.subheading}>
        Data from Google Sheet: 1n4z89NEg4wkPnFu-cDX-aKN5Us3f2CLREC1ZA1pRc9Y
      </Text>

      <Box sx={cryptoQuantStyles.tableContainer} position="relative" minHeight="300px">
        {loading ? (
          <Box height="300px">
            <LoadingBubbles height="100%" />
          </Box>
        ) : (
          renderContent()
        )}
      </Box>
    </Box>
  )
}

export default CryptoQuantDetailedSentiments
